export default __webpack_public_path__ + "static/media/kitchen3-afterG-1440w.32ea2224.webp";